import { useState } from "react"
import { doc, setDoc, getDoc } from "firebase/firestore"
import { db } from "../../services/firebase"
import { parsearCSVViajes } from "../../utils/destinoUtils"

export default function ImportadorViajes({ onImportado }) {
  const [csv, setCsv]           = useState("")
  const [preview, setPreview]   = useState([])
  const [importando, setImportando] = useState(false)
  const [resultado, setResultado]   = useState(null)
  const [error, setError]       = useState("")
  const [paso, setPaso]         = useState("pegar")

  function handleParsear() {
    setError("")
    if (!csv.trim()) return setError("Pega el contenido del CSV primero.")
    const filas = parsearCSVViajes(csv)
    if (filas.length === 0) return setError("No se encontraron datos validos. Verifica el formato.")
    setPreview(filas)
    setPaso("preview")
  }

  async function handleImportar() {
    setImportando(true)
    setError("")
    let ok = 0, actualizados = 0, errores = 0

    for (const viaje of preview) {
      try {
        const { id_cliente, id_viaje, ...datos } = viaje
        if (!id_cliente) { errores++; continue }

        const ref  = doc(db, "usuarios_sheets", id_cliente, "viajes", id_viaje || crypto.randomUUID())
        const snap = await getDoc(ref)

        await setDoc(ref, {
          ...datos,
          importado_en: new Date(),
        }, { merge: true })

        if (snap.exists()) actualizados++
        else ok++
      } catch (e) {
        console.error("Error importando viaje", viaje.id_viaje, e)
        errores++
      }
    }

    setResultado({ ok, actualizados, errores, total: preview.length })
    setPaso("listo")
    setImportando(false)
    if (onImportado) onImportado()
  }

  const inputStyle = {
    width: "100%", padding: "10px 14px", background: "#1a1a1a",
    border: "1px solid #3a3a3a", borderRadius: "8px", color: "#e5e7eb",
    fontFamily: "Inter, sans-serif", fontSize: "0.875rem", outline: "none", resize: "vertical"
  }

  // Contar destinos combinados para mostrar en preview
  const combinados = preview.filter(v => v.destino_medallas && v.destino_medallas.length > 1).length

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

      {/* Instrucciones */}
      <div style={{ background: "#0f2340", border: "1px solid #1e3a5f", borderRadius: "12px", padding: "20px" }}>
        <div style={{ fontWeight: 700, color: "#3b82f6", marginBottom: "10px" }}>Como exportar la planilla de viajes</div>
        {[
          "1. Abri la planilla de viajes en Google Sheets",
          "2. Archivo → Descargar → Valores separados por comas (.csv)",
          "3. Abri el archivo con el Bloc de notas",
          "4. Selecciona todo (Ctrl+A) y copia (Ctrl+C)",
          "5. Pega el contenido abajo"
        ].map((p, i) => (
          <div key={i} style={{ fontSize: "0.875rem", color: "#9ca3af", marginBottom: "4px" }}>{p}</div>
        ))}
        <div style={{ marginTop: "10px", padding: "10px", background: "#1e3a5f", borderRadius: "8px", fontSize: "0.8rem", color: "#60a5fa" }}>
          Columnas esperadas: ID, Viaje, ID Cliente, Fecha de Reserva, Nombre y Apellido, Estado del Viaje, Canal de venta, Referido Por, Fecha de Viaje, Cant Noches, Fecha de Vuelta, Grupo, Telefono, Origen, Destino, Pax, Monto de Venta, Aerolinea, Asistencia al Viajero, Hotel 1, Hotel 2, Incluye
        </div>
      </div>

      {paso === "pegar" && (
        <>
          <div>
            <div style={{ fontSize: "0.8rem", fontWeight: 700, color: "#6b7280", marginBottom: "6px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              Pegar contenido del CSV
            </div>
            <textarea
              rows={10}
              placeholder={"ID,Viaje,ID Cliente,Destino,...\n1,85,29/01/2026,Pestarino Fabrizio,..."}
              value={csv}
              onChange={e => setCsv(e.target.value)}
              style={inputStyle}
            />
          </div>
          {error && (
            <div style={{ padding: "12px 16px", background: "#2a0a0a", border: "1px solid #ef444440", borderRadius: "8px", color: "#ef4444", fontSize: "0.875rem" }}>
              {error}
            </div>
          )}
          <button
            onClick={handleParsear}
            style={{ padding: "12px", background: "#3b82f6", border: "none", borderRadius: "8px", color: "white", fontFamily: "Inter, sans-serif", fontSize: "0.95rem", fontWeight: 700, cursor: "pointer" }}
          >
            Verificar datos
          </button>
        </>
      )}

      {paso === "preview" && (
        <>
          <div style={{ background: "#0a2a1a", border: "1px solid #10b98140", borderRadius: "10px", padding: "14px 18px" }}>
            <div style={{ fontWeight: 700, color: "#10b981", marginBottom: "4px" }}>
              Se encontraron {preview.length} viajes listos para importar
            </div>
            <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>
              {combinados} viajes con destinos combinados — las medallas se asignaran por separado automaticamente.
            </div>
          </div>

          <div style={{ background: "#0f0f0f", border: "1px solid #2a2a2a", borderRadius: "12px", overflow: "hidden", maxHeight: "400px", overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#0a0a0a" }}>
                  {["ID Viaje", "Cliente ID", "Destino normalizado", "Medallas", "Fecha salida", "Monto"].map(h => (
                    <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontSize: "0.75rem", fontWeight: 700, color: "#4b5563", textTransform: "uppercase", borderBottom: "1px solid #2a2a2a" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {preview.map((v, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: "10px 14px", color: "#6b7280", fontSize: "0.8rem", borderBottom: "1px solid #1a1a1a" }}>{v.id_viaje}</td>
                    <td style={{ padding: "10px 14px", color: "#3b82f6", fontWeight: 600, fontSize: "0.8rem", borderBottom: "1px solid #1a1a1a" }}>{v.id_cliente}</td>
                    <td style={{ padding: "10px 14px", color: "#e5e7eb", fontWeight: 600, fontSize: "0.875rem", borderBottom: "1px solid #1a1a1a" }}>{v.destino}</td>
                    <td style={{ padding: "10px 14px", color: "#10b981", fontSize: "0.75rem", borderBottom: "1px solid #1a1a1a" }}>
                      {v.destino_medallas?.join(", ")}
                    </td>
                    <td style={{ padding: "10px 14px", color: "#9ca3af", fontSize: "0.8rem", borderBottom: "1px solid #1a1a1a" }}>{v.fecha_salida}</td>
                    <td style={{ padding: "10px 14px", color: "#f59e0b", fontWeight: 600, fontSize: "0.8rem", borderBottom: "1px solid #1a1a1a" }}>
                      {v.monto_venta ? "$" + v.monto_venta : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={() => { setPaso("pegar"); setPreview([]) }}
              style={{ flex: 1, padding: "12px", background: "#1a1a1a", border: "1px solid #3a3a3a", borderRadius: "8px", color: "#9ca3af", fontFamily: "Inter, sans-serif", fontWeight: 700, cursor: "pointer" }}
            >
              Volver a editar
            </button>
            <button
              onClick={handleImportar}
              disabled={importando}
              style={{ flex: 2, padding: "12px", background: importando ? "#1a1a1a" : "#10b981", border: "none", borderRadius: "8px", color: importando ? "#6b7280" : "white", fontFamily: "Inter, sans-serif", fontSize: "0.95rem", fontWeight: 700, cursor: importando ? "not-allowed" : "pointer" }}
            >
              {importando ? "Importando..." : "Importar " + preview.length + " viajes a Firestore"}
            </button>
          </div>
        </>
      )}

      {paso === "listo" && resultado && (
        <div style={{ background: "#0a2a1a", border: "1px solid #10b98140", borderRadius: "12px", padding: "40px", textAlign: "center" }}>
          <div style={{ fontSize: "2.5rem", marginBottom: "12px" }}>✓</div>
          <div style={{ fontWeight: 800, color: "#10b981", fontSize: "1.1rem", marginBottom: "16px" }}>Importacion completada</div>
          <div style={{ display: "flex", justifyContent: "center", gap: "24px", marginBottom: "20px" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#10b981" }}>{resultado.ok}</div>
              <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>Nuevos</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#3b82f6" }}>{resultado.actualizados}</div>
              <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>Actualizados</div>
            </div>
            {resultado.errores > 0 && (
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: "1.8rem", fontWeight: 800, color: "#ef4444" }}>{resultado.errores}</div>
                <div style={{ fontSize: "0.8rem", color: "#6b7280" }}>Errores</div>
              </div>
            )}
          </div>
          <button
            onClick={() => { setPaso("pegar"); setCsv(""); setPreview([]); setResultado(null) }}
            style={{ padding: "10px 24px", background: "#1a1a1a", border: "1px solid #3a3a3a", borderRadius: "8px", color: "#9ca3af", fontFamily: "Inter, sans-serif", fontWeight: 700, cursor: "pointer" }}
          >
            Importar otro CSV
          </button>
        </div>
      )}

    </div>
  )
}